import React, { useState, useEffect, useRef } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch, useSelector } from "react-redux";
import { dateRangeValue } from "../../redux/selectors/timeSheetDateRangeSelector";
import { setTimeSheetDateRange } from "../../redux/slices/timeSheetDateRangeSlice";
import { formatToWeekYear, getCurrentAndPreviousWeek } from "../../utils/utils";
import ResetWeekIcon from "../../assets/images/ResetWeekIcon.png";

const DateRangePicker = () => {
  const [today, previousWeekDate] = getCurrentAndPreviousWeek();
  const value = useSelector(dateRangeValue);
  const dispatch = useDispatch();
  const range = [{ ...value, key: "selection" }];
  const [tempDateRange, setTempDateRange] = useState(range);
  const [isPickerVisible, setIsPickerVisible] = useState(false);
  const pickerRef = useRef(null);

  const handleSelect = (ranges) => {
    setTempDateRange([ranges.selection]);
  };

  const togglePicker = () => {
    setIsPickerVisible(!isPickerVisible);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setIsPickerVisible(false);
    if (!tempDateRange?.isDefault) {
      setTempDateRange([
        {
          startDate: previousWeekDate,
          endDate: today,
          isDefault: true,
          key: "selection",
        },
      ]);
      dispatch(
        setTimeSheetDateRange({
          startDate: previousWeekDate,
          endDate: today,
          isDefault: true,
          key: "selection",
        })
      );
    }
    // setTempDateRange([
    //   {
    //     startDate: null,
    //     endDate: null,
    //     key: "selection",
    //   },
    // ]);
    // dispatch(
    //   setTimeSheetDateRange({
    //     startDate: null,
    //     endDate: null,
    //   })
    // );
  };

  const handleOk = () => {
    dispatch(
      setTimeSheetDateRange({
        startDate: tempDateRange[0]?.startDate || null,
        endDate: tempDateRange[0]?.endDate || null,
      })
    );
    setIsPickerVisible(false);
  };

  useEffect(() => {
    if (value?.startDate && value?.endDate) {
      setTempDateRange([
        {
          startDate: value?.startDate,
          endDate: value?.endDate,
          key: "selection",
        },
      ]);
    }
  }, [value]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsPickerVisible(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);

  // Disable future dates
  // const disableFutureDates = (date) => {
  //   return date > new Date();
  // };

  return (
    <div>
      <button
        onClick={togglePicker}
        className="date-range-picker__button primary-btn-less-width"
      >
        {value?.startDate && value?.endDate && (
          <>
            <div className="date-range-picker-align-center">
              {`${formatToWeekYear(value?.startDate)} - ${formatToWeekYear(
                value?.endDate
              )}`}
              {!value?.isDefault && (
                <img
                  onClick={(e) => handleCancel(e)}
                  src={ResetWeekIcon}
                  className="date-range-picker__cancel-icon"
                  alt="eyeIcon"
                />
              )}
            </div>
          </>
        )}
      </button>

      {isPickerVisible && (
        <div className={`date-range-picker__container`} ref={pickerRef}>
          <DateRange
            ranges={tempDateRange}
            onChange={handleSelect}
            className="date-range-picker"
            months={2}
            direction="horizontal"
            // disabledDay={disableFutureDates}
          />
          <div className="date-range-picker__button-container">
            <button
              onClick={handleCancel}
              className="date-range-picker__btn-secondary"
            >
              {value?.isDefault ? "Cancel" : "Clear"}
            </button>
            <button
              onClick={handleOk}
              className="date-range-picker__button primary-btn-less-width"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
